import CrmDemographicsTab from "./v2/CrmDemographicsTab";
import {useState} from "react";
import type {DateRange} from "../common/newDatePicker/datePickerShared";
import {createDefaultInsightsRange} from "./v2/insightsDateRangePresets";
import {
    RightSidebarRail,
    RightSidebarRailHeader,
    RightSidebarRailHeaderCenter,
    RightSidebarRailLayout,
} from "../layout/rightSidebar/RightSidebarRail";
import InsightsDateRangeControl from "./v2/base/InsightsDateRangeControl";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {InsightsRailSearch, matchesTitle} from "./kit/InsightsRailSearch";

/** Same cap as the surveys insights page, so both modules centre their content identically. */
const CONTENT_MAX_WIDTH = 1440;

/**
 * Who the guests are, as its own CRM tab. Owns the date range and the scroll container; the body
 * lives in `v2/CrmDemographicsTab`. Budgets are deliberately absent — nothing here is judged
 * against one, so the rail does not offer a dialog that would change nothing on this screen.
 */
export function CrmDemographicsInsightsTab() {
    const [range, setRange] = useState<DateRange>(createDefaultInsightsRange);
    const [compareRange, setCompareRange] = useState<DateRange | null>(null);
    const [query, setQuery] = useState("");
    const [isContentScrolled, setIsContentScrolled] = useState(false);

    return (
            <RightSidebarRailLayout>
                <RightSidebarRailHeader>
                    <RightSidebarRailHeaderCenter>
                        <InsightsDateRangeControl
                            range={range}
                            compareRange={compareRange}
                            onChange={selection => {
                                setRange(selection.range);
                                setCompareRange(selection.compareRange);
                            }}
                        />
                    </RightSidebarRailHeaderCenter>
                </RightSidebarRailHeader>

                <Divider sx={{borderColor: isContentScrolled ? "divider" : "transparent"}}/>

                <Box
                    onScroll={event => setIsContentScrolled(event.currentTarget.scrollTop > 0)}
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        minHeight: 0,
                        overflowY: "auto",
                        pt: {xs: 2, md: 3},
                        pb: {xs: 6, md: 9},
                        px: {xs: 2, md: 3},
                    }}
                >
                    <Stack sx={{width: "100%", maxWidth: CONTENT_MAX_WIDTH, mx: "auto", minWidth: 0}}>
                        <CrmDemographicsTab
                            range={range}
                            compareRange={compareRange}
                            matches={(title, key) => matchesTitle(query, title, key)}
                        />
                    </Stack>
                </Box>

                <RightSidebarRail>
                    <InsightsRailSearch query={query} onQueryChange={setQuery}/>
                </RightSidebarRail>
            </RightSidebarRailLayout>
    );
}

export default CrmDemographicsInsightsTab;
